import { CustomRailsContext } from 'Types'

const contextElement = document.getElementById('js-react-on-rails-context')
const contextText = contextElement?.textContent
if (!contextText) console.error('Rails context not found')

const railsContext: CustomRailsContext = JSON.parse(contextText ?? '{}')

export { railsContext }
